






































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { mapActions } from "vuex";
import CdkFilterPassBadge from "@/components/CdkFilterPassBadge/CdkFilterPassBadge.vue";

@Component({
  components: {
    CdkFilterPassBadge
  },
  methods: {
    ...mapActions("filters", ["updateFilterIsVisible"])
  }
})
export default class CdkSettingsFilterList extends Vue {
  @Prop() filtersByGroup!: any[];

  @Prop(Boolean) showActions!: boolean;

  @Prop(String) filterId!: string;

  hideActionSettings = [];

  updateFilterIsVisible: any;

  get showHideAction() {
    return (index, ownerFiltersIndex) =>
      // @ts-ignore
      this.hideActionSettings[index][ownerFiltersIndex].showHideAction;
  }

  /**
   * toggleOrNavigate - Navigates to the settings of the selected filter if the
   * selected filter is not this.filter, otherwise expand or collapse filter sub-items
   *
   * @param  {Boolean} $0.active - Whether the filter is expanded
   * @param {String} $0.filterId - The id of the filter
   */
  toggleOrNavigate({ active, index, filterId }) {
    const filter = this.filtersByGroup[index].find(
      item => item.id === filterId
    );
    if (filter && filter.id === this.filterId) {
      filter.active = active;
    } else {
      this.$emit("switchFilter", { filterId });
    }
  }

  /**
   * toggleHideAction - Sets the visibility of the hide/unhide actions of the filter
   *
   * @param  {Number} $0.index
   * @param  {type} $0.ownerFiltersIndex
   */
  toggleHideAction({ index, ownerFiltersIndex }) {
    const { showHideAction } = this.hideActionSettings[index][
      ownerFiltersIndex
    ];
    Vue.set(this.hideActionSettings[index], ownerFiltersIndex, {
      showHideAction: !showHideAction
    });
  }

  created() {
    // NB: hide action is 'hidden' by default
    this.hideActionSettings = this.filtersByGroup.map(ownerFilters =>
      ownerFilters.map(() => ({
        showHideAction: false
      }))
    );
  }
}
